import * as _ from 'lodash'
import * as React from 'react'
import { Link } from 'react-router-dom'
import ReactTable, { CellInfo } from 'react-table'
import LocalizationStore from '../Stores/LocalizationStore'
import QuestionnairesStore from '../Stores/QuestionnairesStore'
import { getTroubleEventStatusClass, getTroubleEventStatusText, getTroubleEventTypeText } from './TroubleEvent'

export function createColumns() {
    const localizationStore = LocalizationStore.getInstance()
    return [
        {
            Header: localizationStore.t('troubleEventId'),
            maxWidth: 330,
            minWidth: 120,
            accessor: 'id',
            Cell: (cellInfo: CellInfo) => (
                <Link
                    className="qDetailLink"
                    to={'/troubleevent/' + cellInfo.row.id}
                    id={cellInfo.row.id}
                >
                    {cellInfo.row.id}
                </Link>
            ),
            sortable: false,
        },
        {
            Header: localizationStore.t('createDate'),
            accessor: 'createDate',
            maxWidth: 200,
            minWidth: 100,
            sortable: false,
            // filterMethod: (filter: any, row: any) =>
            //     -1 !== row[filter.id].toUpperCase().indexOf(filter.value.toUpperCase())
        },
        {
            Header: localizationStore.t('troubleEventType'),
            accessor: 'type',
            maxWidth: 300,
            minWidth: 100,
            Cell: (cellInfo: CellInfo) => (
                <span className="">
                    {getTroubleEventTypeText(cellInfo.row.type)}
                </span>
            ),
            filterable: false,
            sortable: false,
            // filterMethod: (filter: any, row: any) =>
            //     -1 !== getTroubleEventTypeText(row[filter.id])
            //         .toUpperCase()
            //         .indexOf(filter.value.toUpperCase())
        },
        {
            Header: localizationStore.t('troubleEventStatus'),
            accessor: 'status',
            maxWidth: 300,
            minWidth: 140,
            Cell: (cellInfo: CellInfo) => (
                <span className={getTroubleEventStatusClass(cellInfo.row.status)}>
                    {getTroubleEventStatusText(cellInfo.row.status)}
                </span>
            ),
            filterable: false,
            sortable: false,
            // filterMethod: (filter: any, row: any) =>
            //     -1 !== getTroubleEventStatusText(row[filter.id])
            //         .toUpperCase()
            //         .indexOf(filter.value.toUpperCase())
        },
        {
            Header: localizationStore.t('inProgressByUserId'),
            accessor: 'assignedUserId',
            Cell: (cellInfo: CellInfo) => (
                <Link
                    className="userDetailLink"
                    to={'/user/' + cellInfo.row.assignedUserId}
                    id={cellInfo.row.assignedUserId}
                >
                    {cellInfo.row.assignedUserId}
                </Link>
            ),
            maxWidth: 400,
            minWidth: 100,
            filterable: false,
            sortable: false,
        }
    ]
}

export function getEventsFromQ() {
    const localizationStore = LocalizationStore.getInstance()

    return (
        <div>
            <p className="font-weight-bold text-center">{localizationStore.t('Events')}</p>
            <div>
                <ReactTable
                    pages={1}
                    data={
                        _.orderBy(
                            QuestionnairesStore.getInstance().getItem.credit.troubleEvents,
                            x => x.createDate,
                            'desc')
                    }
                    columns={createColumns()}
                    defaultPageSize={5}
                    className={'-striped -highlight'}
                    noDataText={localizationStore.t('No data text')}
                    // filterable={true}
                    pageSizeOptions={[5, 10, 20, 25, 50, 100]}
                    previousText={localizationStore.t('Previous')}
                    nextText={localizationStore.t('Next')}
                    pageText={localizationStore.t('Page')}
                    ofText={localizationStore.t('of')}
                    manual
                // onFetchData={_.debounce(onFetchTEData, 777)}
                />
            </div>
        </div>
    )
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/Model/TroubleEventsTableSimpleItem.tsx